module.exports = __webpack_public_path__ + "img/microphone.39e84ebd.svg";